import { render } from "./UserSignUpTab.vue?vue&type=template&id=09a9ea5a"
import script from "./UserSignUpTab.vue?vue&type=script&lang=js"
export * from "./UserSignUpTab.vue?vue&type=script&lang=js"
script.render = render

export default script